import { Stack } from "@mui/material";
import { Icon, type IconName } from "components/Icon";

type ScenarioMetricItemProps = {
  iconName: IconName;
  label: string;
  value: number | string;
};

export const ScenarioMetricItem = ({ iconName, label, value }: ScenarioMetricItemProps) => (
  <Stack className="w-full items-start justify-between gap-1">
    <Stack className="items-center gap-1">
      <Icon iconName={iconName} svgClassName="h-3.5 w-3.5" />
      <span className="text-lds-foreground-muted font-ds-body-regular-xxs">{label}</span>
    </Stack>
    <span className="text-lds-foreground-primary font-ds-body-semibold-sm">{value}</span>
  </Stack>
);
